export default __webpack_public_path__ + "static/media/SuperFiction.7bd89baa.png";